<template>
  <el-drawer :visible.sync="visible" direction="ltr" :with-header="false" custom-class="drawer-modal" @opened="onOpen"
    :show-close="false" :before-close="beforeClose" :withHeader="false">
    <div class="header">
      <el-form size="small" :inline="true">
        <el-form-item label="地址搜索" v-if="visible">
          <address-search :area="area" @select="select" style="width: 400px" />
        </el-form-item>
        <el-form-item>
          <el-button style="width: 100px; margin-right: 20px" type="primary" @click="onOK">确定选择</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div id="locationSelectMap" class="map-b"></div>
  </el-drawer>
</template>

<script>
const markB = require("../assets/image/mark_b.png");
import { reverseGeocoding } from "@/api";

export default {
  data() {
    return {
      visible: false,
      area: null,
      reverseGeocodeTimer: null,
      reverseGeocodeSeq: 0
    };
  },

  methods: {
    show(point, area, callback) {
      this.point = point;
      this.area = area;
      this.callback = callback;
      this.visible = true;
    },

    onOpen() {
      this.showMap();
    },

    showMap() {
      const map = new AMap.Map("locationSelectMap", {
        resizeEnable: true,
        dragEnable: true,
        zoom: 14
      });

      this.map = map;

      // AMap.plugin(["AMap.PlaceSearch", "AMap.AutoComplete"], () => {
      //   const autoOptions = {
      //     // input 为绑定输入提示功能的input的DOM ID
      //     input: "locationSelectInput",
      //     city: this.area || "全国",
      //   };
      //   const autoComplete = new AMap.AutoComplete(autoOptions);
      //   autoComplete.on("select", this.select);
      // });

      const { lat, lng } = this.point || {};
      if (lat && lng) {
        this.addMarker(this.point);
      }
    },

    onOK() {
      if (this.marker) {
        this.visible = false;
        const { lat, lng } = this.marker.getPosition();
        const extData = this.marker.getExtData();
        this.callback({ lat, lng, name: extData.title });
      } else {
        this.$message.error("请确定一个地点");
      }
    },

    select(poi) {
      this.addMarker(poi);
    },

    addMarker(poi) {
      if (this.marker) {
        this.map.remove(this.marker);
      }
      const position = [+poi.lng, +poi.lat];
      const marker = new AMap.Marker({
        position,
        title: poi.name,
        icon: new AMap.Icon({
          image: markB
        }),
        anchor: "bottom-center",
        draggable: true,
        label: {
          //修改label相对于maker的位置
          direction: "top",
          content: "<div class='info active'>" + poi.name + "</div>"
        },
        extData: {
          title: poi.name
        }
      });

      marker.on("dragend", (e) => {
        const { lat, lng } = e.lnglat;
        this.debouncedReverseGeocoding(lat, lng);
      });

      this.marker = marker;
      this.map.add(marker);
      this.map.setCenter(position);
    },

    beforeClose(done) {
      if (this.map) {
        this.map.clearMap();
      }
      if (this.reverseGeocodeTimer) {
        clearTimeout(this.reverseGeocodeTimer);
        this.reverseGeocodeTimer = null;
      }
      done && done();
    }
    ,
    debouncedReverseGeocoding(lat, lng) {
      if (lat == null || lng == null) return;

      if (this.reverseGeocodeTimer) {
        clearTimeout(this.reverseGeocodeTimer);
      }

      const seq = ++this.reverseGeocodeSeq;
      // 拖拽结束后短时间内可能连续触发，这里做防抖避免大量请求
      this.reverseGeocodeTimer = setTimeout(() => {
        reverseGeocoding(lat, lng).then((res) => {
          // 丢弃旧请求结果，避免覆盖最新地址
          if (seq !== this.reverseGeocodeSeq) return;
          const address = res.data;
          if (address && this.marker && this.marker.setLabel) {
            this.marker.setLabel({
              content: "<div class='info active'>" + address + "</div>"
            });
            this.marker.setExtData({
              title: address
            });
          }
        });
      }, 300);
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .drawer-modal {
  width: 50% !important;
}

#locationSelectMap {
  width: 100%;
  height: 100%;
  flex: 1;
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 16px 0 0 20px;
  background-color: #ddd;
}

#locationSelectInput {
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  border: none;
  outline: none;
}
</style>
